import {MxSelector, MxSelectorCreator} from '../store.types';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {QueryParamsState} from './query-params.state';
import {QUERY_PARAMS_FEATURE_KEY} from './query-params.types';
import {Params} from '@angular/router';

// For each app to call in an adapter file, using its own RouteName type.
export function createQueryParamsSelectors<RouteNameType extends string = string>() {
  const entireState: MxSelector<QueryParamsState<RouteNameType>> = createFeatureSelector<QueryParamsState<RouteNameType>>(QUERY_PARAMS_FEATURE_KEY);

  const hasCachedParamsFor: MxSelectorCreator<[RouteNameType], boolean> =
    routeName => createSelector(
      entireState,
      state => routeName in state
    );

  const cachedParamsFor: MxSelectorCreator<[RouteNameType], Params> =
    routeName => createSelector(
      entireState,
      state => state[routeName] ?? {}
    );

  return {
    entireState,
    hasCachedParamsFor,
    cachedParamsFor
  } as const;
}

// For Aviary use only.
export const QueryParamsSelectors = createQueryParamsSelectors<string>();
